import React, { Component } from 'react';
import { Field } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import DropDownSearchInput from '../../app/common/Form/DropDownSearchInput';
import { getNetBankingOptions } from './DropDownActions';
import { getCDNpath } from '../../app/common/util';

const mapState = (state) => ({
  async: state.async,
  netBanking: state.options.netBanking,
});

const actions = {
  getNetBankingOptions,
};

 class BanksDropdown extends Component {

  static propTypes = {
    async: PropTypes.object.isRequired,
    getNetBankingOptions: PropTypes.func.isRequired,
    netBanking: PropTypes.object,
  };

  constructor(props) {
    super(props);

    const { getNetBankingOptions, netBanking } = props;
    if (typeof getNetBankingOptions === 'function' && !netBanking) {
      getNetBankingOptions();
    }
  }

  render() {
    const { netBanking, async, name, value } = this.props;
    // Parse & format banks array for select input
    let bankOptions = [];
    let priorityBanks = [];
    if(netBanking && netBanking.priorityBanks) {
      priorityBanks = netBanking && netBanking.priorityBanks && Array.isArray(netBanking.priorityBanks) && netBanking.priorityBanks.map((bank, index) => {
        return {
          key: bank.bankCode + index, 
          text: bank.bankName, 
          value: bank.bankCode,
          image: {direction: 'right', src: getCDNpath(`/static/images/banks/${bank.bankCode}.png`)}
        }
      });
    }

    let parsedBanks = [];
    if(netBanking && netBanking.banks) {
      parsedBanks = netBanking && netBanking.banks && Array.isArray(netBanking.banks) && netBanking.banks.map((bank, index) => {
        return {
          key: bank.bankCode + index, 
          text: bank.bankName, 
          value: bank.bankCode,
          image: { src: getCDNpath(`/static/images/banks/${bank.bankCode}.png`)}
        }
      });
    }

    bankOptions = priorityBanks.concat(parsedBanks);

    return (
      <React.Fragment>
        <Field
          value={value}
          placeholder="Select Bank"
          options={bankOptions}
          component={DropDownSearchInput}
          name={name}
          loading={async.key === 'netbank' ? async.loading : false}
          noResultsMessage={
            async.key === 'netbank' && async.error
              ? 'Server Error, Unable to Fetch'
              : (async.loading) ? 'Fetching, please wait . . .' : 'Not found!'
          }
        />
      </React.Fragment>
    );
  }
}


export default connect(mapState, actions)(BanksDropdown);
